import React, { useEffect, useState } from 'react';
import Image from 'next/image';
import { createCompleteAddress, joinPhoneNumbers } from '@utils';
import CallIcon from '@images/map-search-call-icon.svg';
import EmailIcon from '@images/map-search-email-icon.svg';
const InfoBoxComponent = ({ center }) => {
  const phoneNumber = joinPhoneNumbers(center?.phone1, center?.phone2);
  if (!center) {
    return null;
  }
  return (
    <div id="content">
      <h1 className="mapInfoTitle">{center.centerName}</h1>
      <div id="bodyContent">
        {center.centerMode === 'InPerson' && (
          <div className="mapInfoaddress">
            {createCompleteAddress({
              streetAddress1: center.streetAddress1,
              streetAddress2: center.streetAddress2,
              city: center.city,
              zipCode: center.postalCode,
              state: center.state,
            })}
          </div>
        )}
        {phoneNumber && (
          <div className="mapInfoLine">
            <Image
              className="icon"
              src={CallIcon}
              alt="call"
              width={24}
              height={24}
            />
            {phoneNumber}
          </div>
        )}
        {center.email && (
          <div className="mapInfoLine">
            <Image
              className="icon"
              src={EmailIcon}
              alt="email"
              width={24}
              height={24}
            />
            {center.email}
          </div>
        )}
      </div>
    </div>
  );
};

export default InfoBoxComponent;
